import { parsePhoneNumberFromString, type CountryCode } from "libphonenumber-js"

const COUNTRY_TO_ISO: Record<string, CountryCode> = {
  ch: "CH",
  nl: "NL",
  de: "DE",
}

/** Returns true if the input parses as a valid phone number. */
export function validatePhone(input: string, country?: string): boolean {
  if (!input) return false
  const iso = country ? COUNTRY_TO_ISO[country] : undefined
  const parsed = parsePhoneNumberFromString(input, iso)
  return parsed?.isValid() ?? false
}

/** Returns a display-formatted phone string. Falls back to the input if unparseable. */
export function formatPhoneDisplay(input: string, country?: string): string {
  const iso = country ? COUNTRY_TO_ISO[country] : undefined
  const parsed = parsePhoneNumberFromString(input, iso)
  return parsed?.formatInternational() ?? input
}
